import React, { JSX } from 'react';
import { useHistory } from 'react-router';

import { EvNoTenant } from '@evinced-private/ui-common';

import { EXTERNAL_HUBSPOT_SOURCE } from '../../consts/hubspot-consts';
import { RoutesHelper } from '../../helpers/RoutesHelper';
import { useUserTenant } from '../../providers/userTenantProvider/UserTenantProvider';
import { getUserEmail } from '../../services/AuthenticationService';

export const NoTenantPage = (): JSX.Element => {
	const { tenant } = useUserTenant();
	const history = useHistory();
	if (tenant) {
		history.push(RoutesHelper.getHomepagePath());
		return null;
	}

	return (
		<EvNoTenant
			portalId={import.meta.env.VITE_HUBSPOT_API_KEY}
			externalHubspotSource={EXTERNAL_HUBSPOT_SOURCE}
			userEmail={getUserEmail()}
			onSignUpWithEmail={() => history.push(RoutesHelper.getSignupPath())}
		/>
	);
};
